import { FC } from 'react'

import { EntityPickerIcon, EntityEditIcon, NonSelectableWidgetInputContainer } from '../widget-styles'
import { UnitPickerInput } from './styles'

type UnitPickerProps = {
    selectedUnitName?: string
    isRounded?: string
}

const UnitPicker: FC<UnitPickerProps> = ({ selectedUnitName, isRounded }) => {
    return (
        <NonSelectableWidgetInputContainer isRounded={isRounded}>
            <EntityPickerIcon />
            <UnitPickerInput value={selectedUnitName}></UnitPickerInput>
            <EntityEditIcon />
        </NonSelectableWidgetInputContainer>
    )
}

export default UnitPicker
